var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":false,"height":80,"width":80,"color":"#007BFF","opacity":0.5},on:{"update:active":function($event){_vm.isLoading=$event}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }